import { getApiClient } from '@src/services/api-client'
import { MutationFunction, useMutation } from '@tanstack/react-query'
import { makeGetCsv } from '../make-api'

const REPORT_NEWSLETTER = '/ReportNewsLetter'

const reportNewsLetterApiLegacy = makeGetCsv(REPORT_NEWSLETTER)

async function downloadReportNewsLetter() {
  const apiClient = getApiClient()
  return reportNewsLetterApiLegacy(apiClient)
}

export function useReportNewsLetterExport(): [MutationFunction<void, void>, boolean] {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: downloadReportNewsLetter,
  })

  return [mutateAsync, isPending]
}
